export default (obj: {[prop: string]: any}) => {
    const newObj: {[prop: string]: any} = {};
    for (const [prop, value] of Object.entries(obj)) {
        if (value) {
            newObj[prop] = value;
        }
    }
    return newObj;
};
